import React from 'react';

const CampaignSchedule = () => {
    return (
        <div>

        </div>
    );
};

export default CampaignSchedule;